import { Component, ComponentType } from 'react'
import { connect } from 'react-redux'
import { isMobileSelector, isMobileOrTabletSelector } from 'selectors/viewportSelectors'
import { createSelector } from 'reselect'
import { Omit } from 'interfaces'
import { hoistNonReactStatics } from 'tangle-shared'

type WithMobileStateProps = {
  isMobile: boolean
  isMobileOrTablet: boolean
}

export type WithMobileProps = WithMobileStateProps

function withMobile<TProps extends WithMobileStateProps> (InnerComponent: ComponentType<TProps>) {
  class SaturatedComponent extends Component<TProps & WithMobileProps> {
    render () {
      return (
        <InnerComponent { ...this.props } />
      )
    }
  }

  const mapStateToProps = createSelector(
    isMobileSelector,
    isMobileOrTabletSelector,
    (isMobile, isMobileOrTablet) => ({ isMobile, isMobileOrTablet })
  )

  const SaturatedComponentWithStatics = hoistNonReactStatics(SaturatedComponent, InnerComponent)
  return connect<WithMobileStateProps, {}, Omit<TProps, keyof WithMobileStateProps>>(mapStateToProps)(SaturatedComponentWithStatics)
}

export default withMobile
